/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiClient } from '../api';
import { Path } from '../api/backendUrl';

export interface Favorite {
  id?: string;
  _id?: string;
  favoriteId?: string;
  userId?: string;
  serviceId?: string;
  providerId?: string;
  createdAt?: string;
  updatedAt?: string;
  // Allow additional fields without breaking
  [key: string]: any;
}

// GET /api/v1/favorite - Get all favorites for authenticated user
export const getAllFavorites = async (): Promise<any> => {
  const res = await apiClient.get(
    `${import.meta.env.VITE_APP_BACKEND_SERVICE}${Path.favorite}`
  );
  return res.data;
};

// GET /api/v1/favorite/count - Get favorite count for user
export const getFavoriteCount = async (): Promise<any> => {
  const res = await apiClient.get(
    `${import.meta.env.VITE_APP_BACKEND_SERVICE}${Path.favorite}/count`
  );
  return res.data;
};

// GET /api/v1/favorite/check/:serviceId - Check if a service is favorited
export const checkFavorite = async (serviceId: string): Promise<any> => {
  if (!serviceId) throw new Error('serviceId is required');
  const res = await apiClient.get(
    `${import.meta.env.VITE_APP_BACKEND_SERVICE}${Path.favorite}/check/${serviceId}`
  );
  return res.data;
};

// GET /api/v1/favorite/:favoriteId - Get specific favorite by ID
export const getFavoriteById = async (favoriteId: string): Promise<any> => {
  if (!favoriteId) throw new Error('favoriteId is required');
  const res = await apiClient.get(
    `${import.meta.env.VITE_APP_BACKEND_SERVICE}${Path.favorite}/${favoriteId}`
  );
  return res.data;
};

// GET /api/v1/favorite - Get paginated favorites list
export const getFavorites = async (
  params: { page?: number; limit?: number } = {}
): Promise<any> => {
  const { page = 1, limit = 10 } = params;
  const res = await apiClient.get(
    `${import.meta.env.VITE_APP_BACKEND_SERVICE}${Path.favorite}?page=${page}&limit=${limit}`
  );
  return res.data;
};

// POST /api/v1/favorite - Add service to favorites
export const addFavorite = async (serviceId: string): Promise<any> => {
  if (!serviceId) throw new Error('serviceId is required');
  const res = await apiClient.post(
    `${import.meta.env.VITE_APP_BACKEND_SERVICE}${Path.favorite}`,
    { serviceId }
  );
  return res.data;
};

// DELETE /api/v1/favorite/:favoriteId - Remove favorite by ID
export const removeFavorite = async (favoriteId: string): Promise<any> => {
  if (!favoriteId) throw new Error('favoriteId is required');
  const res = await apiClient.delete(
    `${import.meta.env.VITE_APP_BACKEND_SERVICE}${Path.favorite}/${favoriteId}`
  );
  return res.data;
};

// DELETE /api/v1/favorite/service/:serviceId - Remove favorite by service ID
export const removeFavoriteByServiceId = async (
  serviceId: string
): Promise<any> => {
  if (!serviceId) throw new Error('serviceId is required');
  const res = await apiClient.delete(
    `${import.meta.env.VITE_APP_BACKEND_SERVICE}${Path.favorite}/service/${serviceId}`
  );
  return res.data;
};
